module.exports = __webpack_public_path__ + "static/media/hearteyes.3b1ae650.gif";